module.exports = __webpack_public_path__ + "static/media/leadership-1.76f9115d.jpg";